<template>
  <div>
    <!-- 配货员首页-->
    <baseBreadcrumb :page="$t('message.distributionIndex')" :menu="$t('message.index')" />
    <div class="body">
      <div class="select">
        <!--  最新更新时间   -->
        {{ $t('message.lastUpdateTime') }} {{ detail.refresh_time }}
      </div>
      <!-- 列表 -->
      <div class="list">
        <div class="row" v-for="(item, index) in tableData" :key="index">
          <div class="type" v-for="(type, typeIndex) in item.row" :key="typeIndex" :style="{ borderColor: type.color }">
            <div class="head"> <span :style="{ background: type.color }"></span> {{ locale == 'zh' ? type.head :
              type.head_jp }}</div>
            <div class="item" v-for="(items, indexs) in type.list" :key="indexs" :style="{ background: type.background }"
              @click.stop="link(items.link)">
              <div class="num" :style="{ background: type.color }">{{ items.v }}</div>
              <div class="name">
                {{ locale == 'zh' ? items.tag : items.tag_jp }}
              </div>
              <!-- 紧急 -->
              <div class="exigency" v-if="items.overdue != null" @click.stop="overdueLink(items.link)"> {{
                $t('message.overdue') }} ({{ items.overdue }})</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: '',
      options: [],
      tableData: [
        {
          row: [
            {
              color: '#6FD882 ',
              background: '#ECF9ED ',
              head: '商品跟进',
              head_jp: '商品フォロー',
              name: 'order_detail',
              list: [

              ]
            },
           
          ]
        },
        {
          row: [
            {
              color: '#FF7364 ',
              background: '#FFEFF0',
              head: '配送单待处理',
              head_jp: '配送依頼書処理',
              name: 'porder',
              list: [

              ]
            },
            {
              color: '#B882FF ',
              background: '#FFEFFD',
              head: '问题产品处理状态',
              head_jp: '问题产品处理状态',
              name: 'problem_handle',
              list: [

              ]
            },
          ]
        },
        {
          row: [
            {
              color: '#F6C05D',
              background: '#FCF7EA',
              head: '装箱单',
              head_jp: '梱包',
              name: 'order_box',
              list: [

              ]
            },
            {
              color: '#7C98FF',
              background: '#F0F5FC',
              head: '本月赔款单',
              head_jp: '梱包',
              name: 'reparation',
              list: [

              ]
            },

          ]
        },
        

      ],
      detail: {},
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
  },
  created() {
    this.dashboardIndex()
  },
  watch: {
    locale() {
      this.dashboardIndex()
    },
  },
  methods: {
    dashboardIndex() {
      this.$api.dashboardIndex({ lang: this.locale == 'ja' ? 'jp' : '' }).then(res => {
        this.detail = res.data
        this.tableData.forEach(item => {
          item.row.forEach(items => {
            for (let key in this.detail.list) {
              if (items.name == key) {
                items.list = this.detail.list[key]
              }
            }
          })
        })
        console.log(res.data.list);
      })
    },
    // 跳转
    link(link) {
      window.open('#/' + link, "_blank");
    },
    //跳转紧急
    overdueLink(link) {
      let href = ''
      if (link.indexOf('?') === -1) {
        href = '#/' + link + '?overdue=1'
      } else {
        href = '#/' + link + '&overdue=1'
      }
      window.open(href, "_blank");
    }
  }
}
</script>
<style lang='scss' scoped>
/deep/ .el-select {
  width: 320px;

  .el-input__inner {
    height: 50px;
  }
}

.list {
  display: flex;

  .row {
    flex: 1;
    margin-right: 24px;

    &:nth-last-child(1) {
      margin: 0;
    }

    .type {
      padding: 24px;
      border: 1px solid #ccc;
      border-radius: 8px;
      margin-top: 24px;
      background-color: #fff;

      .head {
        height: 24px;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 24px;
        margin-bottom: 22px;
        display: flex;

        span {
          margin-right: 12px;
          height: 24px;
          width: 4px;
          border-radius: 2px;
        }
      }

      .item {
        margin-top: 12px;
        padding: 12px 17px 12px 12px;
        background-color: pink;
        border-radius: 8px;
        display: flex;
        line-height: 32px;
        position: relative;
        cursor: pointer;

        .num {
          padding: 0 5px;
          min-width: 22px;
          height: 32px;
          background: #FF7364;
          border-radius: 4px;
          text-align: center;
          font-weight: bold;
          color: #fff;
          font-size: 16px;
          margin-right: 15px;
        }

        .name {
          font-size: 16px;
        }

        .exigency {
          position: absolute;
          top: 12px;
          right: 17px;
          font-size: 16px;
          color: #FF7364;
          font-weight: bold;
        }
      }
    }
  }
}
</style>